module.exports = __webpack_public_path__ + "static/media/kia-thumbs.05a2ad1e.svg";